import React from 'react'

const Social = () => {
  return (
    <div className="home_social">
        <a href="https://x.com/bigharrr?s=21" className="home_social-icon" target='blank'><i className="uil uil-twitter"></i></a>
        <a href="https://github.com/coderQoce" className="home_social-icon" target='blank'><i className="uil uil-github"></i></a>
        <a href="https://www.linkedin.com/in/oke-quadri-3068b0243?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" className="home_social-icon" target='blank'><i className="uil uil-linkedin"></i></a>
    </div>
  )
}

export default Social